module.exports = __webpack_public_path__ + "static/media/tarot-card-4.98120aa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/tarotcards/tarot-card-4.jpg
// module id = 144
// module chunks = 0